<template>
  <div>
    <div class="row">
      <div class="col-2">
        <h3 class="card-title" v-if="loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN">Application Status:
          <el-select class="filter-select mr-2 mb-2" v-model="GrantForm.status" placeholder="Choose application status" @change="changeApplicationStatus">
            <el-option v-for="item in applicationStatuses" :key="item" :label="item.toUpperCase()" :value="item"/>
          </el-select>
        </h3>
      </div>
      <div class="col-2">
        <h3 class="card-title" v-if="GrantForm.hasRevision &&( loggedUser.role === UserRoles.ADMIN || loggedUser.role === UserRoles.REGIONAL_ADMIN)">Revision Status:
          <el-select class="filter-select mr-2 mb-2" v-model="GrantForm.hasRevision.status" placeholder="Choose revision status" @change="changeRevisionStatus">
            <el-option v-for="item in revisionStatuses" :key="item" :label="item.toUpperCase()" :value="item"/>
          </el-select>
        </h3>
      </div>
      <div class="col-8">
        <export-application class="float-right" v-if="applicationId" :application-id="applicationId" :grant-id="grantId" :has-revision="GrantForm.hasRevision" :concept-status="conceptStatus"></export-application>
        <div v-if="GrantForm.hasRevision && (loggedUser.role == UserRoles.ADMIN || loggedUser.role == UserRoles.REGIONAL_ADMIN)" class="text-right float-right mb-3 mr-3">
          <base-button @click="validateRevision()" type="default" size="lg" class="btn-fill text-right">
            Validate Revision
          </base-button>
        </div>
      </div>
    </div>
    <component-loader
      :key="$i18n.locale"
      v-if="componentInitialized"
      :component-name="componentName"
      :default-component-name="defaultComponentName"
      id="applicationComponent"
    >
    </component-loader>
  </div>
</template>
<script>
  import {EventBus} from '@/event-bus.js';
  import {ApplicationService, UserRoles, GrantService, FileUploadService, GrantForm} from '@/services';
  import swal from 'sweetalert2';
  import {GrantWizard, GrantWizardTab, ExportApplication} from 'src/components';
  import ComponentLoader from './ComponentLoader';
  import {Select, Option} from 'element-ui';


  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      GrantWizard,
      GrantWizardTab,
      ComponentLoader,
      ExportApplication
    },
    data() {
      return {
        UserRoles,
        GrantForm,
        grantId: parseInt(this.$route.params.grantId),
        regionId: parseInt(this.$route.params.regionId),
        //budgetPercentage : parseInt(this.$route.params.budgetPercentage),
        applicationId: parseInt(this.$route.params.applicationId) || null,
        appversion: parseInt(this.$route.params.appversion),
        isCn: this.$route.params.isCn,
        conceptStatus: this.$route.params.conceptStatus,
        applicationStatuses: [
          'draft',
          'submitted',
        ],
        revisionStatuses: [
          'draft',
          'submitted',
        ],
        componentInitialized: false,
        componentName: 'Dynamic',
        defaultComponentName: 'Default',
        data: {}
      }
    },
    async beforeCreate() {
      let loader = this.$loading.show();
      const grantId = parseInt(this.$route.params.grantId);
      const applicationId = parseInt(this.$route.params.applicationId) || 0;
      const isCn = this.$route.params.isCn;
      const conceptStatus = this.$route.params.conceptStatus;
      const appversion = parseInt(this.$route.params.appversion);
      const loggedUser = this.$store.getters['Auth/loggedUser'];
      this.loggedUser = loggedUser;

      const objectAssignDeep = require('object-assign-deep');

      GrantForm.init();

      await GrantService.get(grantId).then((response) => {
        let componentName = response.data.componentName;
        //select cn component
        if(grantId == 2 && response.data.cnStatus == 1){
          if(conceptStatus == "conceptNote" || applicationId == 0){
            componentName = response.data.cnComponentName;
          }
          else if(conceptStatus == "Preselected"){
            componentName = "ConceptFullProposal/index"
          }
        }
        else if(grantId == 3 && appversion == 1){
          componentName = "NewSmallTechnicalGrant/index"
        }

        switch (response.data.type) {
          case 'dynamic':
            break;

          case 'static':
            this.componentName = componentName;
            break;
        }

        let schema = JSON.parse(response.data.schema);

        GrantForm.model = _.cloneDeep(schema);
        GrantForm.files = _.cloneDeep(schema);

        GrantForm.revisionModel = _.cloneDeep(schema);

        this.componentInitialized = true;
      })

      GrantForm.isEditable = false;
      GrantForm.isRevisionEditable = false;
      GrantForm.hasRevision = false;

      if (!applicationId) {
        // creating new application
        GrantForm.initialized = true;
        GrantForm.isEditable = true;
        GrantForm.isRevisionEditable = false;
        GrantForm.regionId = this.regionId;
        GrantForm.newApplication = this.appversion;
        GrantForm.budgetPercentage = this.budgetPercentage;
        GrantForm.disableConcept = false;

        loader.hide();
        return;
      }

      // existing application
      await ApplicationService.getGrantApplication({
        grantId: grantId,
        applicationId: applicationId
      }).then((response) => {
        GrantForm.model = objectAssignDeep(GrantForm.model, response.data.model);
        GrantForm.files = {...GrantForm.files, ...response.data.files};

        GrantForm.revisionModel = objectAssignDeep(GrantForm.revisionModel, GrantForm.model, GrantForm.revisionModel, response.data.revisionModel);
        GrantForm.regionId = response.data.regionId;
        GrantForm.newApplication = response.data.newApplication;
        GrantForm.title = response.data.title;
        GrantForm.status = response.data.status;
        GrantForm.reference = response.data.reference;
        GrantForm.cnEvaluationStatus = response.data.cnEvaluationStatus;
        if(response.data.fp == 1){
          GrantForm.isEditable = !response.data.locked && (loggedUser['id'] === response.data.userId && (!response.data.status || response.data.status === 'draft'));
          GrantForm.disableConcept = true;
        }
        else if(response.data.fp == 0){
          GrantForm.isEditable = !response.data.locked && (loggedUser['id'] === response.data.userId && (!response.data.cnStatus || response.data.cnStatus === 'DRAFT'));
          GrantForm.disableConcept = false;
        }
        
        GrantForm.isRevisionEditable = response.data.hasRevision && (loggedUser['id'] === response.data.userId && (!response.data.hasRevision.status || response.data.hasRevision.status === 'draft'));

        GrantForm.hasRevision = response.data.hasRevision;

        // setting filesize limit to state
        GrantForm.fileSizeLimit = response.data.uploadMaxFilesize;

        GrantForm.initialized = true;
      }).catch((error) => {
        // could be permission error
        alert(error.data.error);
        this.$router.push('/')
      })

      loader.hide();
    },
    mounted() {
      EventBus.$off('wizard-save-progress');
      EventBus.$off('wizard-complete-progress');

      EventBus.$off('grant-save-progress');
      EventBus.$on('grant-save-progress', data => {
        this.saveProgress();
      });

      EventBus.$off('grant-complete-progress');
      EventBus.$on('grant-complete-progress', data => {
        this.saveProgress('submitted');
      });

      //concept-note save
      EventBus.$off('cn-grant-save-progress');
      EventBus.$on('cn-grant-save-progress', data => {
        this.cnSaveProgress('draft');
      });
      //concept-note submit
      EventBus.$off('cn-grant-complete-progress');
      EventBus.$on('cn-grant-complete-progress', data => {
        this.cnSaveProgress('submitted');
      });

      EventBus.$off('wizard-next-step');
      EventBus.$on('wizard-next-step', data => {
      })
    },
    methods: {
      async saveProgress(status) {
        let data = GrantForm.model;
        let revisionData = GrantForm.revisionModel;
        let loader = this.$loading.show();
        let isSuccess = false;
        let hasClosed = false;

        await ApplicationService.submitApplication({
          grantId: this.grantId,
          userId: this.$store.getters['Auth/loggedUser'].id,
          applicationId: this.applicationId,
          data: data,
          revisionData: revisionData,
          regionId: GrantForm.regionId,
          title: GrantForm.title,
          isRevision: GrantForm.isOnARevisionTab,
          status: status,
          newApplication: GrantForm.newApplication,
        }).then((response) => {
          this.applicationId = response.data.applicationId;
          isSuccess = true;
          hasClosed = response.data.hasClosed;

        }).catch((error) => {
          if (error.data.error === 'permission_error') {
            alert(error.data.error);
            this.$router.push('/ongoing-applications');
          } else {
            alert(error.data.error);
            this.$router.push('/');
          }
        });

        if (!isSuccess) {
          loader.hide();
          return;
        }

        await this.uploadFiles();

        loader.hide();

        if (hasClosed)
        {
          this.showNotification('call-ended');
        }
        else if (status === 'submitted' || status === 'revised-submitted') {
          this.showNotification('complete-progress');
        } else {
          this.showNotification('save-progress');
        }

        if (status !== undefined && status === 'submitted') {
          this.$router.push('/ongoing-applications');
        }
      },
      //concept note save - by alan 
      async cnSaveProgress(status) {
        
        let data = GrantForm.model;
        let revisionData = GrantForm.revisionModel;
        let loader = this.$loading.show();
        let isSuccess = false;
        let hasClosed = false;
        
        if(status == 'submitted'){
          data.technical = {...data.cndescription,...data.cnorgnization,...data.cnesms};
        }

        await ApplicationService.submitConceptNote({
          grantId: this.grantId,
          userId: this.$store.getters['Auth/loggedUser'].id,
          applicationId: this.applicationId,
          data: data,
          revisionData: revisionData,
          regionId: GrantForm.regionId,
          title: GrantForm.title,
          isRevision: GrantForm.isOnARevisionTab,
          status: status
        }).then((response) => {
          
          this.applicationId = response.data.applicationId;
          isSuccess = true;
          hasClosed = response.data.hasClosed;

        }).catch((error) => {
          if (error.data.error === 'permission_error') {
            alert(error.data.error);
            this.$router.push('/ongoing-applications');
          } else {
            alert(error.data.error);
            this.$router.push('/');
          }
        });

        if (!isSuccess) {
          loader.hide();
          return;
        }

        await this.uploadFiles();

        loader.hide();

        if (hasClosed)
        {
          this.showNotification('call-ended');
        }
        else if (status === 'submitted' || status === 'revised-submitted') {
          this.showNotification('complete-progress');
        } else {
          this.showNotification('save-progress');
        }

        if (status !== undefined && status === 'submitted') {
          this.$router.push('/ongoing-applications');
        }
      },

      submitApplication(data) {
        ApplicationService.submitApplication(data);
      },

      changeApplicationStatus()
      {
        let vm = this;

        if (confirm('Are you sure you want to change application status?'))
        {
          if(vm.conceptStatus == "conceptNote"){
              ApplicationService.changeConceptApplicationStatus({
              grantId: vm.grantId,
              applicationId: vm.applicationId,
              status: GrantForm.status,
              });
          }
          else{
              ApplicationService.changeApplicationStatus({
              grantId: vm.grantId,
              applicationId: vm.applicationId,
              status: GrantForm.status,
              });
          }
          
        }
      },

      changeRevisionStatus()
      {
        let vm = this;

        if (confirm('Are you sure you want to change revision status?'))
        {
          ApplicationService.changeRevisionStatus({
            grantId: vm.grantId,
            applicationId: vm.applicationId,
            status: GrantForm.hasRevision.status,
          });
        }
      },

      showNotification(type) {
        if (type === 'save-progress') {
          swal({
            title: this.$t('general.notification__success'),
            html: this.$t('general.notification__progress_saved').split("\n").join("<br>"),
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary btn-fill',
            type: 'success'
          });
        } else if (type === 'complete-progress') {
          swal({
            title: this.$t('general.notification__success'),
            html: this.$t('general.notification__application_submitted').split("\n").join("<br>"),
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary btn-fill',
            type: 'success'
          });
        } else if (type === 'call-ended') {
          swal({
            title: this.$t('general.notification__warning'),
            html: this.$t('general.notification__deadline_passed').split("\n").join("<br>"),
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-primary btn-fill',
            type: 'error'
          });
        }
        else if (type === 'revision-validated')
        {
            swal({
              title: this.$t('general.notification__success'),
              html: this.$t('general.notification__revision_validated').split("\n").join("<br>"),
              buttonsStyling: false,
              confirmButtonClass: 'btn btn-primary btn-fill',
              type: 'success'
            });
        }
      },

      async uploadFiles() {
        
        let files = GrantForm.files;
        let promises = [];

        for (var section in files) {
          if (GrantForm.files.hasOwnProperty(section)) {

            for (var subSection in files[section]) {
              if (files[section].hasOwnProperty(subSection)) {

                let fileToUpload = files[section][subSection];
                if (fileToUpload instanceof File) {

                  let formData = new FormData();
                  formData.append('file', fileToUpload);
                  formData.append('section', fileToUpload.section);
                  formData.append('type', fileToUpload.cntype ? fileToUpload.cntype : '');
                  formData.append('$section', section);
                  formData.append('$subSection', subSection);
                  if (fileToUpload.id) {
                    formData.append('id', fileToUpload.id);
                  }

                  let promise = FileUploadService.uploadFile({
                    applicationId: this.applicationId,
                    formData: formData
                  }).then(function (response) {
                    let fdSection = formData.get('$section');
                    let fdSubSection = formData.get('$subSection');

                    files[fdSection][fdSubSection] = {
                      id: response.data.id,
                      name: response.data.filename,
                      download: response.data.download
                    };

                  }).catch(function (error) {
                    console.log('err', error);
                  })

                  promises.push(promise);
                }
              }
            }
          }
        }

        return await Promise.all(promises);
      },

      validateRevision()
      {
        const vm = this;

        if (confirm('Are you sure you want to validate this revision?'))
        {
            ApplicationService.validateRevision({
                  grantId: vm.grantId,
                  applicationId: vm.applicationId,
                  status: GrantForm.status,
              }).
              then((response) =>
              {
                  vm.showNotification('revision-validated');
              });
        }
      },
    }
  };
</script>
<style lang="scss">
  .form-group {
    &.has-danger {
      .form-control {
        margin-bottom: 0;
      }
    }
  }
</style>
